const geneindexlist = [
    {
      species: "AmericanLotus2022",
      gene_index:"NL1g_00003.1,NL1g_00026,NL1g_00033",
    },
    {
      species: "AmericanLotus2024",
      gene_index:"chr1.g00006.m1,chr1.g00015,chr1.g00027",
    },
    { species: "AsianLotus", gene_index: "Chr01.g00060.m1,Chr01.g00066,Chr01.g00081", },
    {
      species: "ZiLotus",
      gene_index:"OF25078.mRNA1,OF11483,OF21115"
    },
    
  ];
  export default geneindexlist